const SummaryEntryLabel = ({ text, styleOptions = {} }) => {
  return <div style={{
    fontSize: "1em",
    ...styleOptions
  }}>{text}</div>;
};

export default SummaryEntryLabel;
